"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const NavPills_1 = require("../reusables/NavPills");
const svg_1 = require("../../svg");
const react_2 = require("@osmosys/react");
exports.HomeNav = ({ activeTab }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-none d-sm-block" },
            react_1.default.createElement(NavPills_1.NavPills, { activeTab: activeTab, queryDetailLayout: true, 
                // center
                tabs: [
                    {
                        id: 'emails',
                        name: 'Emails',
                        to: '/emails',
                    },
                    {
                        id: 'workflows',
                        name: 'Workflows',
                        to: '/workflows',
                    },
                    {
                        exact: false,
                        id: 'ads',
                        name: 'Ads',
                        strict: false,
                        to: '/ads',
                    },
                    {
                        id: 'emailTemplates',
                        name: 'Templates',
                        to: '/templates',
                    },
                    {
                        id: 'integrations',
                        name: 'Integrations',
                        to: '/integrations',
                    },
                ] })),
        react_1.default.createElement("div", { className: "d-block d-sm-none" },
            react_1.default.createElement(reactstrap_1.Nav, { className: "justify-content-center mb-2" },
                react_1.default.createElement(reactstrap_1.NavItem, null,
                    react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/emails", className: "text-reset" },
                        react_1.default.createElement(react_2.OsmosysLogo, { height: "1.4em", width: "1.4em" }))),
                react_1.default.createElement(reactstrap_1.NavItem, null,
                    react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/workflows", className: "text-reset" },
                        react_1.default.createElement(svg_1.WorkflowsLogo, { height: "1.4em", width: "1.4em" }))),
                react_1.default.createElement(reactstrap_1.NavItem, null,
                    react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/templates", className: "text-reset" },
                        react_1.default.createElement(svg_1.TemplatesLogo2, { height: "1.4em", width: "1.4em" }))),
                react_1.default.createElement(reactstrap_1.NavItem, null,
                    react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/ads", className: "text-reset" },
                        react_1.default.createElement(svg_1.AdsManagerLogo, { height: "1.4em", width: "1.4em" }))),
                react_1.default.createElement(reactstrap_1.NavItem, null,
                    react_1.default.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, to: "/integrations", className: "text-reset" },
                        react_1.default.createElement(svg_1.IntegrationsLogo, { height: "1.4em", width: "1.4em" })))))));
};
//# sourceMappingURL=HomeNav.js.map